import styled from 'styled-components'

import MenuEntryLink from './MenuEntryLink'
import { mobileMenuLinkStyles } from './styles/mobile-menu'

const StyledMenuEntryLink = styled(MenuEntryLink)`
  ${mobileMenuLinkStyles};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.brand.red};
  text-transform: uppercase;
  @media (min-width: 768px) {
    font-weight: 700;
  }
`

export default StyledMenuEntryLink
